








import Vue from 'vue';
import AppProgressSpinner from '@/components/layout/AppProgressSpinner.vue';
import AppErrorPopups from '@/components/layout/AppErrorPopups.vue';
import { mapGetters, mapState } from 'vuex';

export default Vue.extend({
  name: 'App',
  components: {
    AppProgressSpinner,
    AppErrorPopups,
  },
  computed: {
    ...mapGetters('global', ['hasErrors']),
    ...mapState('global', ['loading']),
    ...mapGetters('auth', ['isLogged']),
  },
  watch: {
    isLogged() {
      if (!this.isLogged) {
        this.$router.push('/login');
      }
    },
  },
});
